import { articleWorkspaceStyles } from '@texas/resources/theme/styles/entityWorkspace';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  title: string;
  className?: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function ManagementCard({
  title,
  className,
  description,
  action,
  children,
}: Props) {
  return (
    <Box className={className} sx={articleWorkspaceStyles.card}>
      <Flex
        justify="space-between"
        align="center"
        px={6}
        py={5}
        borderBottom="1px solid"
        borderColor="articleManagement.border"
      >
        <Box>
          <Heading fontFamily="barlow" fontSize="xl">
            {title}
          </Heading>
          {description && (
            <Text color="articleManagement.mutedText" fontSize="sm" mt={1}>
              {description}
            </Text>
          )}
        </Box>
        {action}
      </Flex>
      <Box p={6}>{children}</Box>
    </Box>
  );
}
